import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardMedia, useTheme, Grid, Box } from '@mui/material';
import boardPlaceholderCollection from '../../assets/images/boardPlaceholderCollection.png';
import boardPlaceholderFavourite from '../../assets/images/boardPlaceholderFavourite.png';

const MyDayRecipeCollectionCard = ({
  boardID,
  title,
  coverImageUrl,
  onClickBoard,
  isFavourite,
}) => {
  const theme = useTheme();

  const boardPlaceholder = isFavourite
    ? boardPlaceholderFavourite
    : boardPlaceholderCollection;

  return (
    <Card
      className="my-day-compact-content-card"
      style={{ backgroundColor: theme.palette.primary.cardBackground }}
      sx={{ display: 'flex', flexDirection: 'column' }}
      onClick={(ev) => {
        ev.preventDefault();
        onClickBoard(boardID);
      }}>
      <Box sx={{ position: 'relative' }}>
        <Grid item xs={12}>
          <CardMedia
            sx={{ height: '144px', width: '244px', margin: 'auto' }}
            component="img"
            className="myDayCompactContentEntryCardImage withFilter"
            image={coverImageUrl || boardPlaceholder}
            title={title}
            alt=""
          />
          <div className="myDayCompactContentEntryCardText">{title}</div>
        </Grid>
      </Box>
    </Card>
  );
};

MyDayRecipeCollectionCard.propTypes = {
  boardID: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  coverImageUrl: PropTypes.string.isRequired,
  onClickBoard: PropTypes.string.isRequired,
  isFavourite: PropTypes.bool.isRequired,
};

export default MyDayRecipeCollectionCard;
